import '@fontsource/geist-sans/100.css'
import '@fontsource/geist-sans/200.css'
import '@fontsource/geist-sans/300.css'
import '@fontsource/geist-sans/400.css'
import '@fontsource/geist-sans/500.css'
import '@fontsource/geist-sans/600.css'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import App from './App'
import './index.css'
import { Providers } from './redux-toolkits/providers'
import reportWebVitals from './reportWebVitals'

const root = ReactDOM.createRoot(document.getElementById('root')!)
root.render(
  <Providers>
    <React.StrictMode>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <ToastContainer
          autoClose={3000}
          position="top-center"
          hideProgressBar
          className={'mt-[34px] !w-full gap-4 px-4'}
          toastClassName={(context) => {
            const defaultClass = `
            text-sm md:text-base font-normal
            flex items-center
            rounded-full p-[18px] 
            !min-w-fit !w-fit max-w-[90%] mx-auto
            shadow-lg bg-white my-4
            `

            return `bg-white text-black` + defaultClass
          }}
          closeButton={false}
        />
        <App />
      </LocalizationProvider>
    </React.StrictMode>
  </Providers>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
